<div class="box-border flex w-full flex-col bg-inherit text-base">
  @let hasError = ngControl.errors && ngControl.touched;

  <div
    class="group relative w-full bg-inherit"
    [ngClass]="{
      'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    }">
    @for (option of options(); track $index; let index = $index) {
      @let isValueSelected =
        pickAttributeFromChosenOptions().includes(
          option | toSelectOptionAttribute: valueAttribute()
        );
      <label
        [attr.data-testid]="id() + index | appendTestId: 'label'"
        (change)="selectOption(option)"
        class="my-3 flex cursor-pointer items-center rounded-md bg-inherit px-3 py-2"
        [ngClass]="{
          'pointer-events-none': ngControl.control!.disabled,
          'border-input-error!': hasError,
        }">
        <input
          [attr.data-testid]="id() + index | appendTestId: 'input'"
          type="checkbox"
          [id]="id() | appendTestId: index + ''"
          [name]="name() ? name()! + index : undefined"
          [checked]="isValueSelected"
          class="focus:border-input-focus border-input-ring text-input-focus border-input box-border h-5 w-5 cursor-pointer rounded-sm shadow-xs outline-hidden focus:outline-hidden"
          [ngClass]="{
            'border-input-focus border-2':
              !hasError && !ngControl.control!.disabled && isValueSelected,
            'cursor-not-allowed!': ngControl.control!.disabled,
            'text-input-error! border-input-error!': hasError,
          }"
          [ngStyle]="{
            color: siteContextService.isShopContext()
                ? corporateDesignService.primaryColor()
                : '',
            borderRadius: borderRounding(),
            borderColor: isValueSelected ? inputSelectedColor() : '',
          }" />
        <span
          class="pl-2"
          [ngClass]="corporateDesignService.baseFont()"
          [attr.data-testid]="id() + index | appendTestId: 'option'"
          >{{ option | toSelectOptionAttribute: name() }}</span
        >
      </label>
    }
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
